import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "form-inline float-right" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("label", { for: "history_minutes" }, "Show the last ", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.history_minutes) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.load_sensors && _ctx.load_sensors(...args))),
          class: "form-control mx-sm-3",
          id: "history_minutes"
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("option", {
            type: "number",
            value: "30"
          }, "Thirty minutes", -1),
          _createElementVNode("option", {
            type: "number",
            value: "60"
          }, "One hour", -1),
          _createElementVNode("option", {
            type: "number",
            value: "360"
          }, "Six hours", -1),
          _createElementVNode("option", {
            type: "number",
            value: "1440"
          }, "24 hours", -1)
        ]))], 544), [
          [_vModelSelect, _ctx.history_minutes]
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Loading..."))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.too_many_points)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Too many points in selected period, only showing " + _toDisplayString(_ctx.n_datapoints) + " points. ", 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.n_datapoints) + " datapoint", 1),
                (_ctx.n_datapoints != 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("s")
                    ], 64))
                  : _createCommentVNode("", true),
                _cache[4] || (_cache[4] = _createTextVNode(" received. ", -1))
              ])),
          (_ctx.n_datapoints > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Hover over a point to see the data value. Graph will update automatically every thirty seconds. "))
            : _createCommentVNode("", true),
          _cache[5] || (_cache[5] = _createElementVNode("p", null, [
            _createTextVNode(" For access to older time series data please "),
            _createElementVNode("a", { href: "/grafana" }, "click here to access the Grafana tool.")
          ], -1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "placeholder",
      style: _normalizeStyle({ 'min-height': this.plotHeight, width: '90%', height: '200px' })
    }, null, 4)
  ], 64))
}